// Optional measurements: never queue tool inputs or events before consent.
let consent = false;
let vitalsStarted = false;
export function setAnalyticsConsent(accepted: boolean) {
  consent = accepted;
  if (accepted && !vitalsStarted && typeof window !== 'undefined') {
    vitalsStarted = true;
    void import('web-vitals').then(({ onCLS, onINP, onLCP }) => {
      const report = (metric: { name: string; value: number; id: string; rating: string }) => {
        if (!consent) return;
        window.gtag?.('event', 'web_vitals', { metric_name: metric.name, metric_id: metric.id, value: metric.name === 'CLS' ? Math.round(metric.value * 1000) : Math.round(metric.value), metric_rating: metric.rating, non_interaction: true });
      };
      onCLS(report); onINP(report); onLCP(report);
    }).catch(() => { vitalsStarted = false; });
  }
}
export function trackToolAction(tool: string, action: string, format?: string) {
  if (!consent || typeof window === 'undefined') return;
  window.gtag?.('event', 'tool_complete', { tool_name: tool, action, ...(format ? { format } : {}) });
}
export async function copyResult(text: string, tool: string, action = 'copy', format?: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    trackToolAction(tool, action, format);
    return true;
  } catch { return false; }
}
